import React from "react";
import * as Scroll from "react-scroll";
import {
  HeaderContainer,
  HeaderLogo,
  HeaderMenu,
  HeaderLink,
  HeaderButton,
} from "../../library/header";
import Logo from "../../assets/logo_lbg.svg";

const Header = () => {
  let Link = Scroll.Link;

  return (
    <header style={{ backgroundColor: " #C8F8FF" }}>
      <HeaderContainer background={" #C8F8FF"}>
        <HeaderLogo src={Logo} />
        <HeaderMenu>
          <HeaderLink>
            <Link
              activeClass="active"
              to="home"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              Inicio
            </Link>
          </HeaderLink>
          {/* <HeaderLink>
                        <Link activeClass="active" to="team" spy={true} smooth={true} offset={50} duration={500}>
                            Nuestro Equipo
                        </Link>    
                    </HeaderLink> */}
          <HeaderLink>
            <Link
              activeClass="active"
              to="products"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              La Empresa
            </Link>
          </HeaderLink>
          <HeaderLink>
            <Link
              activeClass="active"
              to="services"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              Nuestro Servicios
            </Link>
          </HeaderLink>
          {/* <HeaderLink>
                        <Link activeClass="active" to="clients" spy={true} smooth={true} offset={50} duration={500}>
                            Clientes
                        </Link>
                    </HeaderLink> */}
          <HeaderButton>
            <Link
              activeClass="active"
              to="contact"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              Contactános
            </Link>
          </HeaderButton>
        </HeaderMenu>
      </HeaderContainer>
    </header>
  );
};

export default Header;
